module.exports = ".color {\r\n    color: #076E9E;\r\n}"